import { AdTargetingParameterProvider } from '../providers/adTargetingParameterProvider';
import { AsyncAction } from '../../base-classes/asyncAction';

export const GET_AD_TARGETING_PARAMETERS = new AsyncAction('GET_AD_TARGETING_PARAMETERS');

export function getAdTargetingParameters(
    baseUrl,
    authId,
    secret,
    verbose,
    stdParams,
    latitude,
    longitude,
    stationId,
    providerId,
    adServer,
    units,
    refresh=false
)
{
    return {
        type: GET_AD_TARGETING_PARAMETERS.base,
        payload: getAdTargetingParametersInternal(
            baseUrl,
            authId,
            secret,
            verbose,
            stdParams,
            latitude,
            longitude,
            stationId,
            providerId,
            adServer,
            units,
            refresh
        )
    };
}


async function getAdTargetingParametersInternal(
    baseUrl,
    authId,
    secret,
    verbose,
    stdParams,
    latitude,
    longitude,
    stationId,
    providerId,
    adServer,
    units,
    refresh=false
) {
    const op = new AdTargetingParameterProvider(baseUrl, authId, secret);
    return await op.getAdTargetingParameters(
        latitude,
        longitude,
        stationId,
        providerId,
        adServer,
        units,
        stdParams,
        refresh,
        verbose
    );
}
